export const LOADING_ROWS_COUNT = 10;

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export const TABLE_CLASSES = {
  container: 'flex h-full w-full flex-col overflow-x-auto px-8 pb-8',
  headCell: 'bg-muted text-muted-foreground',
};
